import React from "react";
import { RiExternalLinkLine } from "react-icons/ri";
import sections from "../data/sectionsdata";
import Ayush from "../images/myimg.jpg";
import achievements from "../data/achievements";

import {
  FaLinkedin,
  FaWhatsapp,
  FaEnvelope,
  FaInstagram,
  FaPhone,
} from "react-icons/fa";

export default function About() {
  return (
    <div className="block pt-24">
      {/* Container for Ayush's image and introduction */}
      <div className="mt-48 mb-64 flex flex-col items-center lg:flex-row lg:items-start lg:justify-center">
        <img
          src={Ayush}
          alt="Ayush"
          className="w-64 h-64 rounded-full"
          data-aos="fade-right"
          data-aos-duration="800"
          data-aos-easing="ease-in-out"
        />
        <div className="block lg:ml-64">
          <p
            className="text-4xl font-bold gradient-text text-center lg:text-left"
            data-aos="fade-left"
            data-aos-duration="1700"
            data-aos-easing="ease-in-out"
          >
            Hi There! I Am Ayush.
          </p>
          <p
            className="text-lg text-gray-300 mb-8 text-center lg:text-center"
            data-aos="fade-left"
            data-aos-duration="1900"
            data-aos-easing="ease-in-out"
          >
            I'm Passionate About Building Digital Worlds.
          </p>
          <div
            className="flex flex-col items-center space-y-4 lg:space-y-0 lg:space-x-4 lg:flex-row lg:justify-center"
            data-aos="fade-left"
            data-aos-duration="2000"
            data-aos-easing="ease-in-out"
          >
            <div className="inline-block bg-gray-200 border border-gray-300 rounded-lg px-6 py-3 text-center transition-colors duration-300 ease-in-out hover:bg-gray-800 hover:text-white w-40 md:w-auto">
              <a
                href="https://drive.google.com/file/d/1Ee1QqFX2B46WFxgtIqdb5bY3idNYtD-l/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
                className="flex items-center justify-center text-gray-800 hover:text-white font-semibold"
              >
                <span>Resume</span>
                <RiExternalLinkLine className="ml-1" />
              </a>
            </div>

            <div className="inline-block bg-blue-500 border border-blue-600 rounded-lg px-6 py-3 text-center transition-colors duration-300 ease-in-out hover:bg-blue-600 hover:text-white w-40 md:w-auto">
              <a
                href="mailto:ayush070503@gmail.com"
                target="_blank"
                rel="noreferrer"
                className="flex items-center justify-center text-white font-semibold"
              >
                <span>Hire Me Now</span>
              </a>
            </div>
          </div>
          <div
            className="inline-block bg-gray-200 border border-gray-300 rounded-lg px-6 py-3 text-center transition-colors duration-300 ease-in-out hover:bg-gray-800 hover:text-white w-full  mt-10"
            data-aos="fade-left"
            data-aos-duration="2000"
          >
            <a
              href="https://ayushverse-blogs.vercel.app/"
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-center text-gray-800 hover:text-white font-semibold"
            >
              <span>AyushVerse: My Blogs</span>
              <RiExternalLinkLine className="ml-1" />
            </a>
          </div>

          {/* Social Icons */}
          <div
            className="fixed bottom-10 right-10 gap-4 lg:space-y-0 lg:space-x-4 lg:flex lg:flex-col lg:items-end hidden lg:flex"
            data-aos="fade-up"
            data-aos-duration="1500"
            data-aos-easing="ease-in-out"
          >
            <span className="text-blue-500 text-2xl opacity-90 hover:opacity-100">
              <a
                href="https://www.linkedin.com/in/ayush0705/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin />
              </a>
            </span>
            <span className="text-green-500 text-2xl opacity-90 hover:opacity-100">
              <a
                href="https://api.whatsapp.com/send?phone=+918882576247&text=Hello%20Ayush!"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaWhatsapp />
              </a>
            </span>
            <span className="text-red-500 text-2xl opacity-90 hover:opacity-100">
              <a href="mailto:ayush070503@gmail.com">
                <FaEnvelope />
              </a>
            </span>
            <span className="text-blue-500 text-2xl opacity-90 hover:opacity-100">
              <a
                href="https://www.instagram.com/rayyush_"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram />
              </a>
            </span>
            <span className="text-blue-500 text-2xl opacity-90 hover:opacity-100">
              <a href="tel:+918882576247">
                <FaPhone style={{ verticalAlign: "middle" }} />
              </a>
            </span>
          </div>
        </div>
      </div>

      {/* Experience Section */}
      <div className="flex flex-col w-full gap-8 p-8">
        <h1
          className="text-3xl font-bold text-center mb-8"
          data-aos="fade-up"
          data-aos-duration="1500"
          data-aos-easing="ease-in-out"
        >
          Experience
        </h1>
        {sections.map((section) => (
          <div
            key={section.id}
            className="relative flex flex-col sm:flex-row w-full max-w-4xl bg-gray-800 rounded-2xl overflow-hidden mx-auto"
            data-aos="fade-up"
            data-aos-duration="1500"
            data-aos-easing="ease-in-out"
            style={{
              border: "4px solid transparent",
              borderRadius: "1rem",
              borderImage:
                "linear-gradient(to right bottom, rgba(173, 216, 230, 0.5), rgba(0, 0, 255, 0.5)) 1",
            }}
          >
            {/* Image Section */}
            <div className="flex-shrink-0 w-full sm:w-1/4 h-48 bg-gray-800 flex items-center justify-center">
              <img
                src={section.image}
                alt={section.title}
                className="max-w-[80%] max-h-[80%] object-contain"
              />
            </div>

            {/* Text Section */}
            <div className="flex-1 p-6 flex flex-col justify-center text-white">
              <h2 className="text-xl font-bold mb-3">{section.title}</h2>
              <p className="text-base">{section.description}</p>
              <a
                href={section.view}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-gray-300 flex items-center mt-1"
              >
                View certificate <RiExternalLinkLine className="ml-1" />
              </a>
            </div>
          </div>
        ))}
      </div>

      {/* Achievements Section */}
      <div className="flex flex-col w-full gap-8 p-8">
        <h1
          className="text-3xl font-bold text-center mb-8"
          data-aos="fade-up"
          data-aos-duration="1500"
          data-aos-easing="ease-in-out"
        >
          Achievements
        </h1>
        {achievements.map((achievement) => (
          <div
            key={achievement.id}
            className="relative flex flex-col sm:flex-row w-full max-w-4xl bg-gray-800 rounded-2xl overflow-hidden mx-auto"
            data-aos="fade-up"
            data-aos-duration="1500"
            data-aos-easing="ease-in-out"
            style={{
              border: "4px solid transparent",
              borderRadius: "1rem",
              borderImage:
                "linear-gradient(to right bottom, rgba(173, 216, 230, 0.5), rgba(0, 0, 255, 0.5)) 1",
            }}
          >
            {/* Image Section */}
            <div className="flex-shrink-0 w-full sm:w-1/4 h-48 bg-gray-800 flex items-center justify-center">
              <img
                src={achievement.image}
                alt={achievement.title}
                className="max-w-[80%] max-h-[80%] object-contain"
              />
            </div>

            {/* Text Section */}
            <div className="flex-1 p-6 flex flex-col justify-center text-white">
              <h2 className="text-xl font-bold mb-3">{achievement.title}</h2>
              <p className="text-base">{achievement.description}</p>
              <a
                href={achievement.view}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-gray-300 flex items-center mt-1"
              >
                View certificate <RiExternalLinkLine className="ml-1" />
              </a>
            </div>
          </div>
        ))}
      </div>
      <hr className="border-gray-600 my-20" />
    </div>
  );
}
